export default __webpack_public_path__ + "static/media/pension.ca96fe42.svg";